import React, { useEffect, useState } from "react";
import AdminDas from "./AdminDas";
import { useSelector } from "react-redux";
import LocationManagerDas from "./LocationManager";
import AuditorDash from "./AuditorDash";
import EmployeeDash from "./EmployeeDas";
import StoreManagerDas from "./StorManagerDas";
import HodDashboard from "./HodDashboard";
const DashboardPage = () => {
 const role=useSelector((state)=>state.auth.user.role||'user')

  switch (role) {
    case "ADMIN":
      return <AdminDas/>;
    case "STORE":
      return <StoreManagerDas/>;
    case "EMPLOYEE":
      return <EmployeeDash/>;
    case "AUDITOR":
      return <AuditorDash/>;
    case "LOCATION":
      return <LocationManagerDas/>;
    case "HOD":
      return <HodDashboard />;  
    default:
      return <div>No dashboard available for your role.</div>;
  }
};

export default DashboardPage;
